const IntensityIcon = () => (
  <svg aria-label="Intensity Icon" role="img" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33333 12.8668C7.4 13.5335 8 14.0002 8.66667 14.0002C9.4 14.0002 10 13.4002 10 12.6668C10 12.4668 10 12.3335 9.93333 12.2002L4.8 1.3335L7.33333 12.8668ZM0 10.6668C0 7.7335 1.53333 5.20016 3.86667 3.80016L4.33333 5.06683C2.53333 6.26683 1.33333 8.3335 1.33333 10.6668C1.33333 11.1335 1.4 11.5335 1.46667 12.0002H0.133333C0.0666667 11.5335 0 11.1335 0 10.6668ZM8 4.00016C7.8 4.00016 7.66667 4.00016 7.46667 4.00016L7 2.7335C7.33333 2.66683 7.66667 2.66683 8 2.66683C12.4 2.66683 16 6.26683 16 10.6668C16 11.1335 15.9333 11.5335 15.8667 12.0002H14.5333C14.6 11.6002 14.6667 11.1335 14.6667 10.6668C14.6667 7.00016 11.6667 4.00016 8 4.00016Z"
    />
  </svg>
);

export default IntensityIcon;
